import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: String(error?.message || error || "Unexpected error") };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("OCTON caught a render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#050505", color: "#e8fbff", padding: 24, textAlign: "center", fontFamily: "system-ui, sans-serif" }} data-testid="app-error-boundary">
          <div style={{ fontSize: 12, letterSpacing: "0.3em", color: "#00e5ff", marginBottom: 10 }}>OCTON · NEURAL HICCUP</div>
          <h1 style={{ fontSize: 26, fontWeight: 800, margin: 0 }}>The brain caught itself.</h1>
          <p style={{ color: "rgba(255,255,255,0.55)", maxWidth: 420, marginTop: 10, fontSize: 14 }}>
            Something glitched, but OCTON is still here. Reload to reconnect to the mothership.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            style={{ marginTop: 20, background: "#ccff00", color: "#000", border: "none", borderRadius: 999, padding: "12px 26px", fontWeight: 700, cursor: "pointer" }}
          >
            Reload OCTON
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
